"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _ReactStaticPage = require("../../../../../react-static/page/ReactStaticPage");

var _Category = require("./Category");

var _Breadcrumbs = require("../../../../../components/Breadcrumb/Breadcrumbs");

var _CategoryTiles = require("../../../category/CategoryTiles");

var _Packing = require("../Packing");

var _mobxReact = require("mobx-react");

var _reactStatic = require("react-static");

var _Core = require("../../../../../components/Core");

var _class;

var CategoryPage = (0, _mobxReact.observer)(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(CategoryPage, _Component);

  function CategoryPage(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = CategoryPage.prototype;

  _proto.render = function render() {
    var categories = this.props.categories;
    var title = _Category.PackingCategoriesTitle;
    return _react.default.createElement(_ReactStaticPage.ReactStaticPage, (0, _extends2.default)({
      title: title
    }, this.props), _react.default.createElement(_Breadcrumbs.Breadcrumbs, {
      items: [{
        label: _Packing.PackingTitle
      }]
    }), _react.default.createElement("p", null, "Select a category to view related items for adding to a travel packing list:"), _react.default.createElement(_Core.Box, {
      mb: 3
    }, _react.default.createElement(_CategoryTiles.CategoryTiles, {
      categories: categories
    })), _react.default.createElement("h2", null, "Packing List by Category"), _react.default.createElement("p", null, "One of the ways to make a packing list is to browse each category and select the items you might need to take. This may work well if you are not sure what to take on your trip and are looking for some ideas. We are building the ultimate selection of items that you may find useful to pack on your next trip."), _react.default.createElement("h3", null, "Incoming Feature"), _react.default.createElement("p", null, "Create your own account and add the items you need to make your custom online packing lists."));
  };

  return CategoryPage;
}(_react.Component)) || _class;

var _default = (0, _reactStatic.withRouteData)(CategoryPage);

exports.default = _default;